import axios from "axios";
import React, { createContext, useEffect, useState } from "react";


export let cartContext = createContext();

export default function CartContextProvider(props) {



  let headers = { token: localStorage.getItem("userToken") };
  function getCartData() {
    return axios.get(
      `https://vehex-production.up.railway.app/cart/getCartWithTotalPrice`,{
        headers,
      }
    );

  }
  function addToCart(productId) {
    
    return axios
      .post(
        "https://vehex-production.up.railway.app/cart/addToCart",
        {
          productId:productId,
          quantity:1,
        },
        {
          headers,
        }
      )
      .then((response) => response)
      .catch((error) => error);
  }

  function removeItem(id) {
    let body = {
        productId: id,
    };
    return axios.delete(`https://vehex-production.up.railway.app/cart/removeCart`, {
        headers: headers, 
        data: body, 
    });
}
    
    function UpdateProductQuantity(id, count) {
    let body = {
      quantity: count,
      productId:id,
    };
    return axios.put(
        `https://vehex-production.up.railway.app/cart/updateCart`,
        body,
        {
        headers,
        }
    );
    }





  return (
    <cartContext.Provider
      value={{
        addToCart,getCartData,removeItem,UpdateProductQuantity
      }}
    >
      {props.children}
    </cartContext.Provider>
  );
}
